import { createFileRoute } from "@tanstack/react-router";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";

export const Route = createFileRoute("/press")({
  head: () => ({
    meta: [
      { title: "Press - Smartasaurus" },
      { name: "description", content: "Press resources, brand assets, and media inquiries for Smartasaurus - the curiosity-driven discovery brand." },
      { property: "og:title", content: "Press - Smartasaurus" },
      { property: "og:description", content: "Brand assets and media inquiries." },
      { property: "og:url", content: "https://smartasaurus.com/press" },
      { name: "twitter:card", content: "summary" },
      { name: "twitter:title", content: "Press - Smartasaurus" },
      { name: "twitter:description", content: "Brand assets and media inquiries." },
    ],
    links: [{ rel: "canonical", href: "https://smartasaurus.com/press" }],
  }),
  component: PressPage,
});

function PressPage() {
  return (
    <div className="min-h-screen bg-background">
      <SiteHeader />
      <main id="main-content" className="mx-auto max-w-3xl px-4 py-20 md:px-8 md:py-28">
        <div className="text-[10px] font-bold uppercase tracking-[0.3em] text-primary">· Press</div>
        <h1 className="mt-3 font-display text-5xl uppercase leading-[0.95] md:text-7xl">
          Press & <span className="text-gradient-curiosity">Media</span>
        </h1>
        <p className="mt-6 max-w-xl text-lg text-muted-foreground">
          Smartasaurus is an independent discovery brand publishing weekly science storytelling
          for curious minds - across web, newsletter, and social.
        </p>

        <div className="mt-12 space-y-6">
          <div className="rounded-2xl border border-border bg-card p-6">
            <div className="text-xs font-bold uppercase tracking-wider text-primary">Media inquiries</div>
            <a href="mailto:support@smartasaurus.com" className="mt-2 block break-all font-display text-xl hover:underline md:text-2xl">
              support@smartasaurus.com
            </a>
            <p className="mt-2 text-sm text-muted-foreground">
              Interviews, features, and editorial collaboration.
            </p>
          </div>

          <div className="rounded-2xl border border-border bg-card p-6">
            <div className="text-xs font-bold uppercase tracking-wider text-primary">Brand assets</div>
            <p className="mt-2 text-sm text-muted-foreground">
              Logos, color palette, and typography guidelines available on request.
            </p>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
